export default {
  state: {
    items: [
      {
        value: 'draft',
        text: 'Draft'
      },
      {
        value: 'scheduling',
        text: 'Scheduling'
      },
      {
        value: 'search',
        text: 'Search'
      },
      {
        value: 'scheduled',
        text: 'Scheduled'
      },
      {
        value: 'driving',
        text: 'Driving'
      },
      {
        value: 'waiting',
        text: 'Waiting'
      },
      {
        value: 'transporting',
        text: 'Transporting'
      },
      {
        value: 'complete',
        text: 'Complete'
      },
      {
        value: 'expired',
        text: 'Expired'
      },
      {
        value: 'canceled',
        text: 'Canceled'
      },
      {
        value: 'failed',
        text: 'Failed'
      }
    ]
  }
}
